module.exports = __webpack_public_path__ + "static/media/beach2384.8ef010b6.jpg";